import React from 'react';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';
import PageMeta from '../components/common/PageMeta';
import Footer from "../components/Home/Footer";
import CtaTwo from '../components/cta/CtaTwo';
import OpenJobs from '../pages/career/OpenJobs';
import CareerPromo from '../pages/career/CareerPromo';
import PageHeader from '../components/common/PageHeader';

const Career = () => {
  return (
    <Layout>
      <PageMeta title="Sunlex" />
      <Navbar />
      <PageHeader
        title="Career"
        desc="Seamlessly actualize client-based users after out-of-the-box value. Globally embrace strategic data through frictionless expertise."
      />
      <OpenJobs />
      <CareerPromo />
      <Footer />
    </Layout>
  );
};

export default Career;
